var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _g4, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationNoProfiles(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 200,
    viewBox: "0 0 209 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z",
    fill: "#EEF755"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-profiles_svg__filter0_d_31_1815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 58H81a6 6 0 00-6 6v75a6 6 0 006 6h64a6 6 0 006-6V64a6 6 0 00-6-6z",
    fill: "#C8D5FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-profiles_svg__filter1_d_31_1815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 50H61a6 6 0 00-6 6v93a6 6 0 006 6h76a6 6 0 006-6V56a6 6 0 00-6-6z",
    fill: "#C8D5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-profiles_svg__filter2_d_31_1815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.003 42.999h-77a6 6 0 00-6 6v108a6 6 0 006 6h77a6 6 0 006-6v-108a6 6 0 00-6-6z",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.102,
    d: "M118 133H61a2 2 0 00-2 2v2a2 2 0 002 2h57a2 2 0 002-2v-2a2 2 0 00-2-2zM107 142H73a2 2 0 00-2 2v1a2 2 0 002 2h34a2 2 0 002-2v-1a2 2 0 00-2-2z",
    fill: "#0D2976"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56.001H70a9 9 0 100 18h38a9 9 0 009-9 9 9 0 00-9-9z",
    fill: "#F6FBA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101c0-10.493-8.507-19-19-19s-19 8.507-19 19 8.507 19 19 19 19-8.507 19-19z",
    fill: "#4B75FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.89 90.5c3.282 0 6.837 2.617 6.837 6.016 0 4.531-4.883 4.609-4.883 6.289V103c0 .547-.43.937-.938.937h-2.851a.925.925 0 01-.938-.937v-.352c0-2.421 1.836-3.398 3.242-4.18 1.172-.663 1.914-1.093 1.914-1.992 0-1.171-1.484-1.913-2.695-1.913-1.523 0-2.266.703-3.242 1.913-.313.391-.898.47-1.29.157l-1.679-1.29c-.43-.273-.508-.859-.234-1.25 1.601-2.304 3.633-3.593 6.758-3.593zm-.39 14.609a2.7 2.7 0 012.695 2.696A2.7 2.7 0 0188.5 110.5c-1.523 0-2.734-1.211-2.734-2.695 0-1.485 1.21-2.696 2.734-2.696z",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-no-profiles_svg__filter3_d_31_1815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z",
    fill: "#FF7181"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.578 29.5l3.906 3.945a1.16 1.16 0 010 1.72l-.859.858a1.16 1.16 0 01-1.719 0L180 32.117l-3.945 3.906a1.16 1.16 0 01-1.719 0l-.859-.859a1.16 1.16 0 010-1.719l3.906-3.945-3.906-3.906a1.16 1.16 0 010-1.719l.859-.86a1.16 1.16 0 011.719 0L180 26.923l3.906-3.906a1.16 1.16 0 011.719 0l.859.859a1.16 1.16 0 010 1.719l-3.906 3.906z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-profiles_svg__filter0_d_31_1815",
    x: 63,
    y: 52,
    width: 100,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-profiles_svg__filter1_d_31_1815",
    x: 43,
    y: 44,
    width: 112,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-profiles_svg__filter2_d_31_1815",
    x: 35.003,
    y: 42.999,
    width: 109,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1815",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-no-profiles_svg__filter3_d_31_1815",
    x: 154,
    y: 7,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0509804 0 0 0 0 0.160784 0 0 0 0 0.462745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_1815"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_31_1815",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNoProfiles);
export default ForwardRef;